import { render } from "./Construct.vue?vue&type=template&id=76ee3eba&scoped=true"
import script from "./Construct.vue?vue&type=script&lang=js"
export * from "./Construct.vue?vue&type=script&lang=js"

import "./Construct.vue?vue&type=style&index=0&id=76ee3eba&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ee3eba"]])

export default __exports__